var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTk = function SvgIconTk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M19.304 5.74a8 8 0 0 0-.156 1.617 7.86 7.86 0 0 0 4.591 7.139c.17-.806.261-1.64.261-2.496 0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12c4.11 0 7.737-2.067 9.9-5.217H6.783v-1.566h16.026q.247-.509.445-1.043H6.783z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.815 6.261.259.797h.838l-.678.493.26.797-.679-.493-.678.493.259-.797-.678-.493h.838zM5.411 12l.324.996h1.048l-.848.616.324.997-.848-.616-.847.616.324-.997-.848-.616h1.048zM5.411 3.652l.324.997h1.048l-.848.616.324.996-.848-.616-.847.616.324-.996-.848-.616h1.048zM2.802 8.347l.324.997h1.048l-.848.616.324.996-.848-.616-.848.616.324-.996-.847-.616h1.047z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconTk;